import React from 'react'
import { FiSettings } from 'react-icons/fi'
import { useSelector } from 'react-redux'
import Location from '../Location/Location'
import './LocationDetails.css'

const LocationDetails = () => {
    const {
        longitude,
        latitude
    } = useSelector(store => store.location)
  return (
    <div className='bg-slate-100 text-slate-800 rounded-md p-5'>
        <h3 className='text-xl font-bold text-left border-b-2 mb-5'>Details</h3>
        <ul className='flex flex-col gap-2'>
            <li className='list-item'>Latitude: {latitude}</li>
            <li className='list-item'>Longitude: {longitude}</li>
            <Location />
        </ul>
    </div>
  )
}

export default LocationDetails